// extracted by mini-css-extract-plugin
module.exports = {"container":"google-ai-path-page_container__bFsCe","testimonials-container":"google-ai-path-page_testimonials-container__yY04N"};